import React from "react"
import { Link } from "react-router-dom"
import Social from "../Social/Social"
import ecLogo from "../../assets/images/ecfoundation1.png"
const classes = require('./Footer.module.scss')

const footer = () => {
  return (
    <footer className={classes.Footer}>
      <div className={[classes.sectionWrap, classes.med3Def, classes.flexGroup].join(' ')}>
        <div className={[classes.ftCol, classes.fc2].join(' ')}>
          <Social where="footer" />
          <p className={[classes.copy, classes.left].join(' ')}>© {(new Date().getFullYear())} Emerald Coast Foundation. <br/>
          501(c)(3) Charity: EIN 55-0796930<br/>
          Design by <a href="http://hsdesignhouse.com" target="_blank" rel="noopener noreferrer">High Seas Design House.</a></p>
        </div>

        <div className={[classes.ftCol, classes.fc3].join(' ')}>
          <Link to="/ec-foundation"><img src={ecLogo} alt="Emerald Coast Foundation Logo" className={[classes.ftLogo].join(' ')} /></Link>
        </div>
      </div>
    </footer>
  )
}

export default footer





